import * as React from 'react';
import { useState } from 'react';
import IconHeart from '../Icons/IconHeart';
import Favourites from '../../libraries/Favourites';

interface FavouriteProductButtonProps {
    productHandle: string
}
const FavouriteProductButton = (props: FavouriteProductButtonProps) => {
    const { productHandle } = props;
    Favourites.init();
    let found = Favourites.isInFavourites(productHandle);
    const [ added, setAdded ] = useState(found);

    const handleClick = () => {
        if (!added) {
            Favourites.addFavourite(productHandle);
            setAdded(true);
        } else {
            Favourites.removeFavourite(productHandle);
            setAdded(false);
        }
    }

    return (
        <button onClick={handleClick} className={`product__favourite favourite ${added ? 'favourite--added' : ''}`} type="button"><IconHeart /></button>
    )
}
export default FavouriteProductButton;
